import { useRef, useState } from 'react';
import CommonStyles from './FJAiToolsItemCommon.module.less';
import Styles from './FJComparePreview.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../../../../store/FJLocalStore';
import ArrowIcon from '../../../../../../assets/svg/community/split-arrow.svg?react';
import PropTypes from 'prop-types';
import FJImage from '../../../../../../common/components/FJImage/FJImage';
import FJConstant from '../../../../../../constants/FJConstant';
import FJUtil from '../../../../../../util/FJUtil';

const FJComparePreview = props => {
    const { name, beforeUrl, afterUrl, jumpLink } = props;

    const _previewItem = useRef();

    const [isHover, setIsHover] = useState(false);
    const [compareScale, setCompareScale] = useState(0.5);
    const [beforeLoadStatus, setBeforeLoadStatus] = useState(FJConstant.LOADING);

    const _onMouseEnter = () => {
        setIsHover(true);
    };

    const _onMouseLeave = e => {
        setIsHover(false);
        const rect = _previewItem.current.getBoundingClientRect();
        const mouseX = e.clientX;
        if (mouseX < rect.x) setCompareScale(0);
        else if (mouseX > rect.x + rect.width) setCompareScale(1);
    };

    const _onMouseMove = e => {
        if (!isHover || !_previewItem.current) return;
        e.stopPropagation();

        // 获取鼠标相对于div的位置
        const rect = _previewItem.current.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const scale = mouseX / rect.width;
        setCompareScale(scale);
    };

    const _onClick = () => {
        if (jumpLink) window.open(jumpLink, '_blank');
        FJUtil.eaLog('ai home ai tool page click', {
            toolName: name.replaceAll('-', ' '),
        });
    };

    const _clipPath = `inset(0px 0px 0px ${compareScale * 100}%)`;
    const _loadCallback = type => {
        setBeforeLoadStatus(type);
    };
    return (
        <div className={CommonStyles.itemBox}>
            <div
                ref={_previewItem}
                className={classNames(CommonStyles.previewBox, Styles.previewBox)}
                onMouseEnter={_onMouseEnter}
                onMouseLeave={_onMouseLeave}
                onMouseMove={_onMouseMove}
                onClick={_onClick}
            >
                <FJImage
                    imgSrc={beforeUrl}
                    alt=''
                    boxClassName={Styles.video}
                    loadCallback={_loadCallback}
                    reloadStyle={{ backgroundColor: '#FFF', zIndex: 22 }}
                />
                {/* <FJImage imgSrc={afterUrl} alt='' boxClassName={Styles.video} imgStyle={{ clipPath: _clipPath }} /> */}
                {beforeLoadStatus === FJConstant.SUCCESS && (
                    <>
                        <img src={afterUrl} alt='' className={Styles.video} style={{ clipPath: _clipPath }} />
                        <div className={Styles.splitLine} style={{ left: compareScale * 100 + '%' }}>
                            <div className={Styles.arrowBox}>
                                <ArrowIcon />
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className={CommonStyles.itemName}>{FJLocalStore._(name)}</div>
        </div>
    );
};

FJComparePreview.propTypes = {
    name: PropTypes.string.isRequired,
    beforeUrl: PropTypes.string.isRequired,
    afterUrl: PropTypes.string.isRequired,
    jumpLink: PropTypes.string.isRequired,
};

export default FJComparePreview;
